<template>
    <van-popup v-model:show="show" :style="{
        minWidth: '100%',
        minHeight: '60%',
        background: 'transparent',
        borderRadius: '10px',
        color: '#95a9d3',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    }">
        <div class="pop_container">
            <div class="close_icon">
                <img src="@/assets/close_bai.png" alt="" @click="close">
            </div>
            <div class="head_icon">
                <img src="@/assets/offers/deposit_promotions_iconcoin.png" alt="">
            </div>
            <div class="content">
                {{ $t('common.deposite') }}
            </div>
            <van-row class="valueContainer">
                <van-col span="2" class="currencyText">R$</van-col>
                <van-col span="20" class="amount">{{ depositValue }}</van-col>
            </van-row>
            <div class="popText">
                {{ $t('offers.depositPopText', {
                    recharge: depositValue, reward: rewardValue
                }) }}
                <span>R$ {{ depositValue + rewardValue }}</span>
            </div>
            <div class="btn_container">
                <MainButton :title="$t('common.deposite')" :onclick="submitDeposit" :activeStatus="true" />
            </div>
        </div>
        <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    </van-popup>
</template>

<script setup lang="ts">
import { rechargeActivity } from '@/api/offers'
import StatusPopup from '@/components/common/statusPopup.vue'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import MainButton from '../../components/common/mainButton.vue'
import { useUserStore } from '@/stores/user'
interface DataItem {
    recharge: string,
    reward: string,
    turnover: string
}
const show = ref(false)
const activityData = ref<DataItem>({
    recharge: "",
    reward: "",
    turnover: ""
})
const userStore = useUserStore()
const depositValue = ref(0)
const rewardValue = ref(0)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const router = useRouter()
const open = (data: any) => {
    show.value = true
    activityData.value = data
    depositValue.value = Number(data.recharge)
    rewardValue.value = Number(data.reward)
}
const close = () => {
    show.value = false
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const submitDeposit = () => {
    userStore.setRechargeBonusType(5)
    localStorage.setItem('showDepositBackIcon', '1')
    router.push({
        path: '/sd-topup',
        query: { value: depositValue.value }
    })
}
defineExpose({
    open,
})

</script>
<style scoped>
.pop_container {
    background: #070a37;
    border: 1px solid #658ce9;
    padding: 15px;
    border-radius: 20px;
    width: 290px;
}

.content {
    padding: 5px 15px;
    font-size: 14px;
    color: #95a9d3;
    line-height: 24px;
}

.content span {
    color: #EFD18D;
}

.van-overlay {
    background-color: #000000bd
}

.close_icon {
    display: flex;
    justify-content: right;
}

.close_icon img {
    width: 25px;
    opacity: 0.5;
}

.head_icon {
    display: flex;
    justify-content: center;
}

.head_icon img {
    width: 55px;
    padding: 25px 0;
}

.btn_container {
    padding: 35px;
}

.valueContainer {
    padding: 8px 15px;
    border-radius: 30px;
    border: 1px solid transparent;
    background: rgba(255, 255, 255, 0.04);
    margin: 5px 15px;
}

.currencyText {
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.amount {
    font-weight: bold;
    font-size: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.popText {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.65);
    padding: 10px 20px;
    line-height: 20px;
}

.popText span {
    color: #FFEE00;
}
</style>